import { css } from '@emotion/css'
import { spacing, shorthandHelper, colors } from '@offerzen/pinata'

const styles = {
  cardFooter: css({
    display: 'flex',
    justifyContent: 'flex-end',
    margin: shorthandHelper([spacing.large, -spacing.large, -spacing.large]),
    padding: shorthandHelper([spacing.medium, spacing.large]),
    borderTop: `1px solid ${colors.mystic}`,
  }),
}

export default styles
